import { IPersonalInfo, ConfigField, IImportData } from '../../../../../types';
import { ApplicationState } from '../../../../../store';

type Fields = Pick<IPersonalInfo, 'givenName' | 'middleName' | 'surname' | 'hasOtherNames' | 'otherNames'>;

type Visible = Record<'givenName' | 'middleName' | 'surname' | 'hasOtherNames', boolean>;

type Mandatory = Record<'givenName' | 'middleName' | 'surname' | 'hasOtherNames', boolean>;

export function getPageStatus(
  config: ApplicationState['config'],
  fields: Fields,
  importData: IImportData
): {
  complete: boolean;
  visible: Visible;
} {
  const { givenName, middleName, surname, hasOtherNames, otherNames } = fields;

  const {
    GivenName: givenNameConfig,
    MiddleName: middleNameConfig,
    FamilyName: surnameConfig,
    HasOtherNames: hasOtherNamesConfig
  }: {
    [key: string]: ConfigField;
  } = config.Checklist.PersonalInfo.Page1;

  const visible: Visible = {
    givenName: givenNameConfig?.visible,
    middleName: middleNameConfig?.visible && !!importData.otherName,
    surname: surnameConfig?.visible,
    hasOtherNames: hasOtherNamesConfig?.visible
  };

  const mandatory: Mandatory = {
    givenName: givenNameConfig?.mandatory,
    middleName: middleNameConfig?.mandatory,
    surname: surnameConfig?.mandatory,
    hasOtherNames: hasOtherNamesConfig?.mandatory
  };

  const allOtherNamesComplete = (amount: number): boolean => {
    let complete = hasOtherNames ? otherNames!.length > 0 : true;
    for (let i = 0; i < amount; i++) {
      complete =
        complete &&
        !!otherNames![i] &&
        (otherNames![i].surname !== '' || otherNames![i].givenName !== '') &&
        otherNames![i].reason !== '';
    }
    return complete;
  };

  // prettier-ignore
  const complete =
    (!visible.givenName || !mandatory.givenName || givenName !== '') &&
    (!visible.middleName || !mandatory.middleName || middleName !== '') &&
    (!visible.surname || !mandatory.surname || surname !== '') &&
    (!visible.hasOtherNames || !mandatory.hasOtherNames || hasOtherNames !== undefined) &&
    allOtherNamesComplete(Number(otherNames!.length));

  return {
    complete,
    visible
  };
}
